import React from 'react'

function MyAccount() {
    return (
        <>
            <h1>My Account page</h1>
        </>
    )
}

export default MyAccount
